module.exports = __webpack_public_path__ + "img/banner-inclusao.6746eccb.png";